import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { DOCUMENT } from '@angular/common';

import { CerAuthorizeService } from 'src/cer-identity/cer-authorize.service';

//import { CredentialResponse } from 'google-one-tap';
//import { environment } from 'src/environments/environment';
declare const FB: any;

@Component({
  selector: 'identity-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  @ViewChild('googleButton', {static: true}) googleButton: ElementRef = new ElementRef({});
  loginForm: FormGroup = new FormGroup({});
  submitted = false;
  errorMessages: string[] = [];
  returnUrl: string | null = null;

  constructor(private authService: CerAuthorizeService,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document) { 
      this.authService.user$.pipe(take(1)).subscribe({
        next: user => {
          if (user) {
            this.authService.navigateToHome();
          } else {
            this.activatedRoute.queryParamMap.subscribe({
              next: (params: any) => {
                if (params) {
                  this.returnUrl = params.get('returnUrl');
                }
              }
            })
          }
        }
      })
    }

  ngOnInit(): void {
    this.initiazeGoogleButton();
    this.initializeForm();
  }

  ngAfterViewInit() {
    //this.googleAddScript();
  }

  private googleAddScript() {
    const script1 = this._renderer2.createElement('script');
    script1.src = 'https://accounts.google.com/gsi/client';
    script1.async = 'true';
    script1.defer = 'true';
    this._renderer2.appendChild(this._document.body, script1);
  }

  initializeForm() {
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
    })
  }

  login() {
    this.submitted = true;
    this.errorMessages = [];

    if (this.loginForm.valid) {
      var v = this.loginForm.value;
      this.authService.login(v.userName, v.password).subscribe({
        next: (_ : any) => {
          if (this.returnUrl) {
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.authService.navigateToHome();
          }
        },
        error: (error: any) => {
          if (error.error.errors) {
            this.errorMessages = error.error.errors;
          } else {
            this.errorMessages.push(error.error);
          }
        }
      })
    }
  }

  loginWithFacebook() {
    FB.login(async (fbResult: any) => {
      if (fbResult.authResponse) {
        const accessToken = fbResult.authResponse.accessToken;
        const userId = fbResult.authResponse.userID;
        
        this.authService.loginWithThirdParty(accessToken, userId, "facebook").subscribe({
          next: () => {
            if (this.returnUrl) {
              this.router.navigateByUrl(this.returnUrl);
            } else {
              this.authService.navigateToHome();
            }
          },
          error: (error: { error: string; }) => {
            this.authService.showNotification(false, "Failed", error.error);
          }
        })
      } else {
        this.authService.showNotification(false, "Failed", "Unable to login with your facebook");
      }
    })
  }

  resendEmailConfirmationLink() {
    this.authService.navigateToResendEmailConfirmationLink();
  }

  private initiazeGoogleButton() {
    (window as any).onGoogleLibraryLoad = () => {
      // @ts-ignore
      google.accounts.id.initialize({
        //client_id: environment.googleClientId,
        //callback: this.googleCallBack.bind(this),
        auto_select: false,
        cancel_on_tap_outside: true
      });
      // @ts-ignore
      google.accounts.id.renderButton(
        this.googleButton.nativeElement,
        {size: 'medium', shape: 'rectangular', text: 'signin_with', logo_alignment: 'center'}
      );
    };
  }

  /*
  private async googleCallBack(response: CredentialResponse) {
    const decodedToken: any = jwt_decode(response.credential);
    this.identityService.loginWithThirdParty(new LoginWithExternal(response.credential, decodedToken.sub, "google"))
      .subscribe({
        next: _ => {
          if (this.returnUrl) {
            this.router.navigateByUrl(this.returnUrl);
          } else {
            this.router.navigateByUrl('/');
          }
        }, error: (error: { error: string; }) => {
          this.sharedService.showNotification(false, "Failed", error.error);
        }
      })
  }
  */
}
